export const formatMoney = (amount, locale) => {
    const hasDecimal = amount - Math.floor(amount) !== 0;

    if (locale === 'CA') {
        return `${getCurrencySymbol(locale)}${amount.toLocaleString('en', {
            minimumFractionDigits: hasDecimal ? 2 : 0,
            maximumFractionDigits: 2,
        })} CAD`;
    }

    return `${getCurrencySymbol(locale)}${amount.toLocaleString('en', {
        minimumFractionDigits: hasDecimal ? 2 : 0,
        maximumFractionDigits: 2,
    })}`;
};

export const getCurrencySymbol = locale => {
    switch (locale) {
        case 'US':
            return '$';

        case 'EU':
            return '€';

        case 'CA':
            return '$';

        default:
            return '$';
    }
};
